// extracted by mini-css-extract-plugin
export default {"popup":"styled_popup__m6Y2h"};